var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DetailTitle',{attrs:{"title":'총 ' + _vm.completeCount + '회 예약'}}),_c('DetailCardContainer',_vm._l((_vm.userReservationList),function(item){return _c('ReservationListItem',{key:item.NUM,attrs:{"item":item},on:{"initRender":_vm.initRender}})}),1),_c('InfiniteLoading',{ref:"infiniteLoading",on:{"infinite":_vm.infinite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }